import { pipe, values } from "remeda";
import { z } from "zod";

export enum StatusCode {
  Ok = 200,
  Created = 201,
  NoContent = 204,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  UnsupportedMediaType = 415,
  ServerError = 500,
  NotImplemented = 501
}

export const ProblemDetails = z.object({
  errors: z.record(z.string(), z.array(z.string())).optional(),
  detail: z.string().optional(),
  instance: z.string().optional(),
  status: z.nativeEnum(StatusCode),
  title: z.string(),
  type: z.string().default('about:blank').optional()
}).passthrough().transform(obj => ({
  ... obj,
  message() {
    if (obj.detail) {
      return obj.detail
    }
    else if (obj.errors) {
      return pipe(values(obj.errors), e => e.flat(), e => e.join('\r\n'))
    }
  }
}))

export type ProblemDetails = z.infer<typeof ProblemDetails>
